if (!customElements.get('career-applications')) {
  customElements.define('career-applications', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-career-tab]')];
      this.panels = [...this.querySelectorAll('[data-career-panel]')];
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.careerTab)));
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      const initial = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
      if (initial) this.select(initial.dataset.careerTab, false);
    }

    select(id, focus = false) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.careerTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.careerPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) this.loadForm(panel);
      });
    }

    onKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || !event.target.matches('[data-career-tab]')) return;
      event.preventDefault();
      const current = this.tabs.indexOf(event.target);
      let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
      if (next < 0) next = this.tabs.length - 1;
      if (next >= this.tabs.length) next = 0;
      this.select(this.tabs[next].dataset.careerTab, true);
    }

    loadForm(panel) {
      if (panel.dataset.formLoaded === 'true' || !panel.dataset.wufooHash) return;
      panel.dataset.formLoaded = 'true';
      const display = () => {
        try {
          const form = new WufooForm();
          form.initialize({
            userName: panel.dataset.wufooUser,
            formHash: panel.dataset.wufooHash,
            autoResize: true,
            height: panel.dataset.wufooHeight,
            async: true,
            host: 'wufoo.com',
            header: 'show',
            ssl: true
          });
          form.display();
        } catch (error) {
          panel.dataset.formLoaded = 'false';
        }
      };
      if (window.WufooForm) {
        display();
        return;
      }
      let script = document.querySelector('script[data-wufoo-embed]');
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://secure.wufoo.com/scripts/embed/form.js';
        script.async = true;
        script.dataset.wufooEmbed = '';
        document.head.appendChild(script);
      }
      script.addEventListener('load', display, { once: true });
    }
  });
}
